module.exports = __webpack_public_path__ + "img/20200513_151646.edf547ba.jpg";